import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Button, Grid, Hidden, Typography, Stack, Skeleton } from "@mui/material";
import Tab from "@mui/material/Tab";
import { tabsClasses } from "@mui/material/Tabs";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useHistory } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { AlertDialog, DrawerComponent, PieCharts } from "../../components";
import { config } from "../../config";
import { AlertContext } from "../../contexts";
import { NetworkCall } from "../../networkcall";
import { Routes } from "../../router/routes";
import { AlertProps, FontFamilySwitch, RetainLocalStorage } from "../../utils";
import {
  NetWorkCallMethods,
  TabContant
} from "../../utils/constants";
import {getTotal} from '../../utils'
import { withNamespaces } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  cardNew: {
    borderRadius: theme.palette.borderRadius2,
    // backgroundColor: theme.palette.background.paper,
    cursor: "pointer",
  },
  Expensestitle: {
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().bold,
  },
  expensesHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#F6F9FF",
    padding: "8px 12px",
    borderTopLeftRadius: theme.palette.borderRadius2,
    borderTopRightRadius: theme.palette.borderRadius2,
    borderBottom: "1px solid #E4E8EE"
  },
  expensesHeader1: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 16px",
  },
  datevise: {
    backgroundColor: "white",
    borderRadius: "6px",
    display: "flex",
    padding: "1px 4px"
  },
  select: {
    backgroundColor: theme.palette.primary.main,
    margin: "5px",
    color: "#fff",
    padding: "3px 5px",
    fontSize: "0.75rem",
    borderRadius: "4px",
    fontFamily:FontFamilySwitch().semiBold,
    cursor: "pointer",
  },
  unselect: {
    margin: "5px",
    color: "#4E5A6B",
    padding: "3px 5px",
    fontSize: "0.75rem",
    borderRadius: "4px",
    fontFamily:FontFamilySwitch().semiBold,
    cursor: "pointer",
  },
  dot: {
    height: "6px",
    width: "6px",
    borderRadius: "50%",
    margin: "6px",
  },
  chartcontant: {
    fontSize: "0.75rem",
    marginRight: "10px",
    color:"#4E5A6B",
    fontFamily: FontFamilySwitch().semiBold,
  },
  textDecoration: {
    color: theme.palette.primary.main,
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().semiBold,
    textDecoration: "underline",
    margin: "10px 0px 0px 35px",
  },
  DrawerClass: {
    borderRadius: "4px 4px 0px 0px",
  },
  closebtn: {
    padding: "10px",
    "& button": {
      backgroundColor: theme.palette.primary.main,
      width: "100%",
      padding: "16px",
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  amountCount: {
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().bold,
  },
  tab: {
    backgroundColor: "#fff",
    borderBottomLeftRadius: theme.palette.borderRadius2,
    borderBottomRightRadius: theme.palette.borderRadius2,
    padding:"16px 16px 10px 16px",
    [theme.breakpoints.up('sm')]: {
      padding:"16px 16px 0 16px",
    },
  },
  skeleton: {
    padding: "12px"
  },
  yearly:{
    fontSize: "0.75rem",
    fontFamily:FontFamilySwitch().semiBold,
  },
  tapButton:{
    height:"40px !important",
    minHeight:"40px",
    "& .MuiButtonBase-root":{
      padding:"0",
      minWidth:"50px",
      minHeight:"50px",
      fontFamily:FontFamilySwitch().bold,
      fontSize: "0.75rem",
      
    }
  }
}));

const HomepageGraph = (props) => {
  const { t = () => false, invoice_charge_type } = props
  const [Yearly, setYearly] = React.useState(true);
  const [Mountly, setMountly] = React.useState(false);
  const [invoiceYear, setInvoiceYear] = React.useState([]);
  const alert = React.useContext(AlertContext);
  // const [agreementID, setAgreementID] = React.useState([]);
  const [YearDataMain, setYearDataMain] = React.useState({
    amount: "",
    symbol: "",
  });
  const [YearDataGeneral, setYearDataGeneral] = React.useState({
    amount: "",
    symbol: "",
  });
  const [YearDataRent, setYearDataRent] = React.useState({
    amount: "",
    symbol: "",
  });
  const [monthDataMain, setMonthDataMain] = React.useState({
    amount: "",
    symbol: "",
  });
  const [monthDataGeneral, setMonthDataGeneral] = React.useState({
    amount: "",
    symbol: "",
  });
  const [monthDataRent, setMonthDataRent] = React.useState({
    amount: "",
    symbol: "",
  });

  const [graphChart , setGraphChart]=React.useState([])
  const [graphChartMonth , setGraphChartMonth]=React.useState([])
  const [invoiceLoading, setInvoiceLoading] = React.useState(true);

  const classes = useStyles(props);
  const history = useHistory();

  // tab functionality && states

  const [value, setValue] = React.useState(null);
  const [value1, setValue1] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    getYearMonth(newValue);
  };
  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
    getMonthData(newValue, value);
  };
  const showMounth = () => {
    setMountly(true);
    setYearly(false);
    getMonthData(value1, value);
  };
  const showYearly = () => {
    setMountly(false);
    setYearly(true);
  };

  // drawer

  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const getYearMonth = (key) => {
    setYearDataMain({
      amount: 0,
      symbol: "",
    });
    setYearDataGeneral({
      amount: 0,
      symbol: "",
    });
    setYearDataRent({
      amount: 0,
      symbol: "",
    });
    const data = {
      year: key,
    };
    NetworkCall(
      `${config.api_url}/invoice/stats`,
      NetWorkCallMethods.post,
      data,
      null,
      true,
      false
    )
      .then((response) => {
        const constractData = response?.data?.data?.map((x)=>{
          return{
            type:x?.type,
            invoice_type_label: invoice_charge_type?.[x?.type] ?? "",
            symbol:x?.symbol,
            value:x?.amount,
            fill: `#${Math.random().toString(16).substring(2, 8)}`
          }
        })
        setGraphChart({
          data:constractData,
          total:getTotal(constractData)
        })
        let temp = response?.data?.data
          .filter((x) => x.type === "Maintenance")
          .map((val) => val);
        temp &&
          temp.length &&
          setYearDataMain({
            amount: temp[0].amount,
            symbol: temp[0].symbol,
          });

        // general
        let tempgeneral = response.data.data
          .filter((x) => x.type === "General")
          .map((val) => val);
        tempgeneral &&
          tempgeneral.length &&
          setYearDataGeneral({
            amount: tempgeneral[0].amount,
            symbol: tempgeneral[0].symbol,
          });

        // rental
        let tempRental = response.data.data
          .filter((x) => x.type === "Rental")
          .map((val) => val);
        tempRental &&
          tempRental.length &&
          setYearDataRent({
            amount: tempRental[0].amount,
            symbol: tempRental[0].symbol,
          });
      })
      .catch((error) => {
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.error,
          msg: t("Some Thing Went Wrong"),
        });
      });
  };

  const getMonthData = (month, year) => {
    setMonthDataMain({
      amount: 0,
      symbol: "",
    });
    setMonthDataGeneral({
      amount: 0,
      symbol: "",
    });
    setMonthDataRent({
      amount: 0,
      symbol: "",
    });
    const data = JSON.stringify({
      year: year,
      month: month + 1,
    });
    NetworkCall(
      `${config.api_url}/invoice/stats`,
      NetWorkCallMethods.post,
      data,
      null,
      true,
      false
    )
      .then((response) => {
        const constractData = response?.data?.data?.map((x)=>{
          return{
            type:x?.type,
            invoice_type_label: invoice_charge_type?.[x?.type] ?? "",
            symbol:x?.symbol,
            value:x?.amount,
            fill: `#${Math.random().toString(16).substring(2, 8)}`
          }
        })
        setGraphChartMonth({
          data:constractData,
          total:getTotal(constractData)
        })
        let temp = response?.data?.data
          .filter((x) => x.type === "Maintenance")
          .map((val) => val);
        temp &&
          temp.length &&
          setMonthDataRent({
            amount: temp[0].amount,
            symbol: temp[0].symbol,
          });

        // general
        let tempgeneral = response.data.data
          .filter((x) => x.type === "General")
          .map((val) => val);
        tempgeneral &&
          tempgeneral.length &&
          setMonthDataMain({
            amount: tempgeneral[0].amount,
            symbol: tempgeneral[0].symbol,
          });

        // rental
        let tempRental = response.data.data
          .filter((x) => x.type === "Rental")
          .map((val) => val);
        tempRental &&
          tempRental.length &&
          setMonthDataGeneral({
            amount: tempRental[0].amount,
            symbol: tempRental[0].symbol,
          });
      })
      .catch((error) => {
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.error,
          msg: t("Some Thing Went Wrong"),
        });
      });
  };

  React.useEffect(() => {

    const { data } = props;

    // {
    //   year: props?.years?.[0]
    // };

    if (data) {

      NetworkCall(
        `${config.api_url}/invoice/stats_years`,
        NetWorkCallMethods.post,
        data,
        null,
        true,
        false
      )
        .then((response) => {
          const tempResponse = response?.data?.data
          const data = tempResponse?.total_invoice_years?.map((v)=>{
            return{
              label: v.toString(),
              value: v.toString()
            }
          })
          setInvoiceYear(data)
          setValue(data?.[0]?.value)

        const constractData = tempResponse?.data?.map((x)=>{
          return{
            type:x?.type,
            invoice_type_label: invoice_charge_type?.[x?.type] ?? "",
            symbol:x?.symbol,
            value:x?.amount,
            fill: `#${Math.random().toString(16).substring(2, 8)}`
          }
          });
          setGraphChart({
            data:constractData,
            total:getTotal(constractData)
        })
          setInvoiceLoading(false)
        }
        )
        .catch((error) => {
          alert.setSnack({
            ...alert,
            open: true,
            severity: AlertProps.severity.error,
            msg: t("Some Thing Went Wrong"),
          });
          setInvoiceLoading(false)
        });
      // setAgreementID(data.agreements.result.map((x) => x.id));
    }
    else {
      RetainLocalStorage();
      history.push(Routes.welcome);
    }
    // eslint-disable-next-line
  }, []);
 
  return (
    <>
      {/* Expenses Pie Chart */}
      <Box sx={{ width: "100%" }} className={classes.cardNew}>
        <Box className={classes.expensesHeader}>
          <Box>
            <Typography variant="subtitle2" className={classes.Expensestitle}>
              {t("dashInvoiceSummary")}
            </Typography>
          </Box>
          <Box>
            <Box className={classes.datevise}>
              {/* yearly */}
              <Box className={Yearly ? classes.select : classes.unselect}>
                <Typography
                  variant="subtitle2"
                  className={classes.yearly}
                  onClick={showYearly}
                >
                  &nbsp;{t("dashYearly")}&nbsp;
                </Typography>
              </Box>
              {/* monthly */}
              <Box className={Mountly ? classes.select : classes.unselect}>
                <Typography
                  variant="subtitle2"
                  className={classes.yearly}
                  onClick={showMounth}
                >
                  {t("dashMonthly")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        {/* yearly */}
        <TabContext value={value}>
          {/* when yearly is show */}
          {Yearly === true && (
            <>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  backgroundColor: "white",
                  height:"40px"
                }}
              >
                {invoiceLoading ? (
                  <div className={classes.skeleton}>
                    <Stack direction={"row"} spacing={5}>
                      <Skeleton width={50} />
                      <Skeleton width={50} />
                    </Stack>
                  </div>
                ) : (
                  <TabList
                    sx={{ padding: "0px", minHeight: "auto" }}
                    className={classes.tapButton}
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    {invoiceYear?.map((val, index) => (
                      <Tab key={index} label={val.label} value={val.value} />
                    ))}
                  </TabList>
                )}
              </Box>

              <TabPanel value={value} className={classes.tab}>
                <Grid container >
                  <Grid item xs={12} sm={7}>
                    <PieCharts
                      data={graphChart?.data ?? []}
                      width={101}
                      YearDataMain={YearDataMain}
                      YearDataGeneral={YearDataGeneral}
                      YearDataRent={YearDataRent}
                      total={graphChart?.total}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    {graphChart?.data?.map((val, index) => {
                      return (
                        <Box key={index}>
                          {/* Rent*/}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              margin: "10px 0px 0px 10px",
                            }}
                          >
                            <Box
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Box
                                className={classes.dot}
                                style={{ backgroundColor: val?.fill }}
                              />
                              <Typography
                                variant="subtitle2"
                                className={classes.chartcontant}
                              >
                                {t(val?.invoice_type_label)}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography
                                variant="subtitle2"
                                className={classes.amountCount}
                              >
                                {val.symbol ? (
                                  <>
                                    {val?.symbol}&nbsp;
                                    {Math.round(val.value)}
                                  </>
                                ) : (
                                  <>0</>
                                )}
                              </Typography>
                            </Box>
                          </div>
                        </Box>
                      );
                    })}
                  </Grid>
                </Grid>
              </TabPanel>
            </>
          )}
        </TabContext>
        {/* mountly */}
        <TabContext value={value1}>
          {/* when show month is show */}
          {Mountly === true && (
            <>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  backgroundColor: "white",
                  height:"40px"
                }}
              >
                <TabList
                  onChange={handleChange1}
                  variant="scrollable"
                  className={classes.tapButton}
                  scrollButtons={true}
                  aria-label="scrollable auto tabs example"
                  sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                      "&.Mui-disabled": { opacity: 0.3 },
                    },
                  }}
                  allowScrollButtonsMobile={true}
                >
                  {TabContant(t).Tabs.map((x, index) => (
                    <Tab key={index} label={x.mounth} value={x.value} />
                  ))}
                </TabList>
              </Box>
              <TabPanel value={value1} className={classes.tab}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12} sm={5}>
                    <PieCharts
                      data={graphChartMonth?.data ?? []}
                      width={111}
                      YearDataMain={monthDataMain}
                      YearDataGeneral={monthDataGeneral}
                      YearDataRent={monthDataRent}
                      total={graphChartMonth?.total}
                    />
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    {graphChartMonth?.data?.map((val, index) => {
                      return (
                        <Box key={index}>
                          {/* Rent*/}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              margin: "10px 0px 0px 10px",
                            }}
                          >
                            <Box
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Box
                                className={classes.dot}
                                style={{ backgroundColor: val?.fill }}
                              />
                              <Typography
                                variant="subtitle2"
                                className={classes.chartcontant}
                              >
                                {console.log(val)}
                                {t(val?.invoice_type_label)}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography
                                variant="subtitle2"
                                className={classes.amountCount}
                              >
                                {val.symbol ? (
                                  <>
                                    {val?.symbol}&nbsp;
                                    {Math.round(val.value)}
                                  </>
                                ) : (
                                  <>0</>
                                )}
                              </Typography>
                            </Box>
                          </div>
                        </Box>
                      );
                    })}
                    {graphChartMonth?.data?.length > 0 && (
                      <Typography
                        className={classes.textDecoration}
                        onClick={toggleDrawer}
                      >
                        {t("dashViewAll")}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </TabPanel>
            </>
          )}
        </TabContext>
        {/* view  drawer in mobile view */}
        <Hidden smUp>
          <DrawerComponent
            open={open}
            toggleDrawer={toggleDrawer}
            onClose={toggleDrawer}
            component={
              <>
                <Box className={classes.expensesHeader1}>
                  <Box>
                    <Typography
                      variant="subtitle2"
                      className={classes.Expensestitle}
                    >
                      {t("dashExpenses")}
                    </Typography>
                  </Box>
                  <Box>
                    <Box className={classes.datevise}>
                      {/* yearly */}
                      <Box
                        className={Yearly ? classes.select : classes.unselect}
                      >
                        <Typography
                          variant="subtitle2"
                          className={classes.yearly}
                          onClick={showYearly}
                        >
                          &nbsp;{t("dashYearly")}&nbsp;
                        </Typography>
                      </Box>
                      {/* monthly */}
                      <Box
                        className={Mountly ? classes.select : classes.unselect}
                      >
                        <Typography
                          variant="subtitle2"
                          className={classes.yearly}
                          onClick={showMounth}
                        >
                          {t("dashMonthly")}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                {/* yearly */}
                <TabContext value={value}>
                  {/* when yearly is show */}
                  {Yearly === true && (
                    <>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          className={classes.tapButton}
                          onChange={handleChange}
                          aria-label="lab API tabs example"
                        >
                          {invoiceYear?.map((val, index) => (
                            <Tab
                              key={index}
                              label={val.label}
                              value={val.value}
                            />
                          ))}
                        </TabList>
                      </Box>

                      <TabPanel value={value}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <PieCharts
                              data={graphChart?.data}
                              width={130}
                              YearDataMain={YearDataMain}
                              YearDataGeneral={YearDataGeneral}
                              YearDataRent={YearDataRent}
                              total={graphChart?.total}
                            />
                          </Grid>
                          <Grid item xs={12}>
                          {
                      graphChart?.data?.map((val,index)=>{
                        return(
                                <Box key={index}>
                                  {/* Rent*/}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      margin: "10px 0px 0px 10px",
                                    }}
                                  >
                                    <Box
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        className={classes.dot}
                                        style={{ backgroundColor: val?.fill }}
                                      />
                                      <Typography
                                        variant="subtitle2"
                                        className={classes.chartcontant}
                                      >
                                        {t(val?.invoice_type_label)}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <Typography
                                        variant="subtitle2"
                                        className={classes.amountCount}
                                      >
                                        {val.symbol ? (
                                          <>
                                            {val?.symbol}&nbsp;
                                            {val.value}
                                          </>
                                        ) : (
                                          <>0</>
                                        )}
                                      </Typography>
                                    </Box>
                                  </div>
                                </Box>
                        )
                      })
                    }
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </>
                  )}
                </TabContext>
                {/* mountly */}
                <TabContext value={value1}>
                  {/* when show month is show */}
                  {Mountly === true && (
                    <>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleChange1}
                          variant="scrollable"
                          className={classes.tapButton}
                          scrollButtons
                          aria-label="scrollable auto tabs example"
                          sx={{
                            [`& .${tabsClasses.scrollButtons}`]: {
                              "&.Mui-disabled": { opacity: 0.3 },
                            },
                          }}
                        >
                          {TabContant(t).Tabs.map((x, index) => (
                            <Tab key={index} label={x.mounth} value={x.value} />
                          ))}
                        </TabList>
                      </Box>
                      <TabPanel value={value1}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <PieCharts
                              data={graphChartMonth?.data}
                              width={130}
                              YearDataMain={monthDataMain}
                              YearDataGeneral={monthDataGeneral}
                              YearDataRent={monthDataRent}
                              total={graphChartMonth?.total}
                            />
                          </Grid>
                          <Grid item xs={12} style={{ marginTop: "-20px" }}>
                            <Box marginLeft="-8px">
                            {
                      graphChartMonth?.data?.map((val, index)=>{
                        return(
                                  <Box key={index}>
                                    {/* Rent*/}
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: "10px 0px 0px 10px",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          className={classes.dot}
                                          style={{ backgroundColor: val?.fill }}
                                        />
                                        <Typography
                                          variant="subtitle2"
                                          className={classes.chartcontant}
                                        >
                                          {t(val?.invoice_type_label)}
                                        </Typography>
                                      </Box>
                                      <Box>
                                        <Typography
                                          variant="subtitle2"
                                          className={classes.amountCount}
                                        >
                                          {val.symbol ? (
                                            <>
                                              {val?.symbol}&nbsp;
                                              {val.value}
                                            </>
                                          ) : (
                                            <>0</>
                                          )}
                                        </Typography>
                                      </Box>
                                    </div>
                                  </Box>
                        )
                      })
                    }
                            </Box>
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </>
                  )}
                </TabContext>
                <div className={classes.closebtn}>
                  <Button variant="contained" onClick={toggleDrawer}>
                    {t("dashClose")}
                  </Button>
                </div>
              </>
            }
          />
        </Hidden>

        {/* view pop up in laptop view */}
        <Hidden smDown>
          <AlertDialog
            open={open}
            toggleDrawer={toggleDrawer}
            onClose={toggleDrawer}
            component={
              <div style={{ width: "100%" }}>
                <Box
                  className={classes.expensesHeader1}
                  style={{ pading: "13px 25px" }}
                >
                  <Box>
                    <Typography
                      variant="subtitle2"
                      className={classes.Expensestitle}
                    >
                      {t("dashExpenses")}
                    </Typography>
                  </Box>
                  <Box>
                    <Box className={classes.datevise}>
                      {/* yearly */}
                      <Box
                        className={Yearly ? classes.select : classes.unselect}
                      >
                        <Typography
                          variant="subtitle2"
                          className={classes.yearly}
                          onClick={showYearly}
                        >
                          &nbsp;{t("dashYearly")}&nbsp;
                        </Typography>
                      </Box>
                      {/* monthly */}
                      <Box
                        className={Mountly ? classes.select : classes.unselect}
                      >
                        <Typography
                          variant="subtitle2"
                          className={classes.yearly}
                          onClick={showMounth}
                        >
                          {t("dashMonthly")}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                {/* yearly */}
                <TabContext value={value}>
                  {/* when yearly is show */}
                  {Yearly === true && (
                    <>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleChange}
                          className={classes.tapButton}
                          aria-label="lab API tabs example"
                        >
                          {invoiceYear?.map((val, index) => (
                            <Tab
                              key={index}
                              label={val.label}
                              value={val.value}
                            />
                          ))}
                        </TabList>
                      </Box>

                      <TabPanel value={value}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <PieCharts
                              data={graphChart?.data ?? []}
                              width={130}
                              YearDataMain={YearDataMain}
                              YearDataGeneral={YearDataGeneral}
                              YearDataRent={YearDataRent}
                              total={graphChart?.total}
                            />
                          </Grid>
                          <Grid item xs={12} style={{ marginTop: "26px" }}>
                          {
                      graphChart?.data?.map((val, index)=>{
                        return(
                                <Box key={index}>
                                  {/* Rent*/}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      margin: "10px 0px 0px 10px",
                                    }}
                                  >
                                    <Box
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        className={classes.dot}
                                        style={{ backgroundColor: val?.fill }}
                                      />
                                      <Typography
                                        variant="subtitle2"
                                        className={classes.chartcontant}
                                      >
                                        {t(val?.invoice_type_label)}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <Typography
                                        variant="subtitle2"
                                        className={classes.amountCount}
                                      >
                                        {val.symbol ? (
                                          <>
                                            {val?.symbol}&nbsp;
                                            {val.value}
                                          </>
                                        ) : (
                                          <>0</>
                                        )}
                                      </Typography>
                                    </Box>
                                  </div>
                                </Box>
                        )
                      })
                    }
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </>
                  )}
                </TabContext>
                {/* mountly */}
                <TabContext value={value1}>
                  {/* when show month is show */}
                  {Mountly === true && (
                    <>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleChange1}
                          className={classes.tapButton}
                          variant="scrollable"
                          scrollButtons
                          aria-label="scrollable auto tabs example"
                          sx={{
                            [`& .${tabsClasses.scrollButtons}`]: {
                              "&.Mui-disabled": { opacity: 0.3 },
                            },
                          }}
                        >
                          {TabContant(t).Tabs.map((x, index) => (
                            <Tab key={index} label={x.mounth} value={x.value} />
                          ))}
                        </TabList>
                      </Box>
                      <TabPanel value={value1}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <PieCharts
                              data={graphChartMonth?.data ?? []}
                              width={130}
                              YearDataMain={monthDataMain}
                              YearDataGeneral={monthDataGeneral}
                              YearDataRent={monthDataRent}
                              total={graphChartMonth?.total}
                            />
                          </Grid>
                          <Grid item xs={12}>
                          {
                      graphChartMonth?.data?.map((val, index)=>{
                        return(
                                <Box key={index}>
                                  {/* Rent*/}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      margin: "10px 0px 0px 10px",
                                    }}
                                  >
                                    <Box
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        className={classes.dot}
                                        style={{ backgroundColor: val?.fill }}
                                      />
                                      <Typography
                                        variant="subtitle2"
                                        className={classes.chartcontant}
                                      >
                                        {val?.invoice_type_label}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <Typography
                                        variant="subtitle2"
                                        className={classes.amountCount}
                                      >
                                        {val.symbol ? (
                                          <>
                                            {val?.symbol}&nbsp;
                                            {val.value}
                                          </>
                                        ) : (
                                          <>0</>
                                        )}
                                      </Typography>
                                    </Box>
                                  </div>
                                </Box>
                        )
                      })
                    }
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </>
                  )}
                </TabContext>
                <div className={classes.closebtn} style={{ padding: "25px" }}>
                  <Button variant="contained" onClick={toggleDrawer}>
                    {t("dashClose")}
                  </Button>
                </div>
              </div>
            }
          />
        </Hidden>
      </Box>

      {/* end */}
    </>
  );
};

export default withNamespaces("dashboard")(HomepageGraph)